import dayjs from "dayjs";
import {Search, RotateCcw} from "lucide-react";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {cn} from "@/utils/utils";
import type {RangeType} from "@/hooks/usePeopleUI";
import type {usePeopleUI} from "@/hooks/usePeopleUI";

const rangeOptions: { value: RangeType; label: string }[] = [
    {value: "all", label: "Все"},
    {value: "year", label: "Год"},
    {value: "month", label: "Месяц"},
    {value: "week", label: "Неделя"},
    {value: "custom", label: "Период"},
];

function ymd(d: Date) {
    return dayjs(d).format("YYYY-MM-DD");
}

export function ClientsFiltersBar({
                                      className,
                                      ui,
                                  }: {
    className?: string;
    ui: ReturnType<typeof usePeopleUI>;
}) {
    return (
        <div className={cn("flex flex-col gap-3 md:flex-row md:items-center md:justify-between", className)}>
            <div className="relative w-full md:max-w-md">
                <Search
                    className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"/>
                <Input
                    value={ui.search}
                    onChange={(e) => ui.actions.setSearch(e.target.value)}
                    placeholder="Поиск по ФИО, телефону, модели..."
                    className="pl-9"
                />
            </div>

            <div className="flex w-full flex-col gap-2 md:w-auto md:flex-row md:items-center">
                <div className="flex w-full gap-2 md:w-auto">
                    <select
                        value={ui.rangeType}
                        onChange={(e) => ui.actions.setRangeType(e.target.value as RangeType)}
                        className={cn(
                            "h-10 w-full rounded-md border border-input bg-background px-3 text-sm outline-none",
                            "focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background md:w-[140px]"
                        )}
                        disabled={ui.tab === "today"}
                    >
                        {rangeOptions.map((o) => (
                            <option key={o.value} value={o.value}>
                                {o.label}
                            </option>
                        ))}
                    </select>

                    <Button variant="outline" onClick={ui.actions.resetFilters} className="h-10 shrink-0"
                            title="Сбросить фильтры">
                        <RotateCcw className="h-4 w-4 md:mr-2"/>
                        <span className="hidden md:inline">Сброс</span>
                    </Button>
                </div>

                {ui.rangeType === "custom" && ui.tab !== "today" && (
                    <div className="flex w-full gap-2 md:w-auto">
                        <Input
                            type="date"
                            value={ymd(ui.startDate)}
                            onChange={(e) => ui.actions.setCustomDates(dayjs(e.target.value).toDate(), ui.endDate)}
                            className="h-10 w-full md:w-[150px]"
                        />
                        <Input
                            type="date"
                            value={ymd(ui.endDate)}
                            onChange={(e) => ui.actions.setCustomDates(ui.startDate, dayjs(e.target.value).toDate())}
                            className="h-10 w-full md:w-[150px]"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
